import Skeleton from 'ui/Skeleton';

const LoadingPage: React.FC = () => (
  <Skeleton.Row width="100%" height="600px" />
);

export default LoadingPage;
